import { mapGetters } from "vuex";
import Talk from "talkjs";
import MiscAPI from "../../../services/api/misc.js";
import BrandAPI from "../../../services/api/brandApi.js";
import { dialogHelper } from "@/components/mixin/dialogHelper";

const RetailerService = new MiscAPI();
const BrandService = new BrandAPI();

export default {
  mixins: [dialogHelper],
  async mounted() {
    if (this.talkSessionLoaded) {
      this.mountInbox();
    }
  },
  computed: {
    talkSessionLoaded() {
      return this.$store.getters.notificationSessionLoaded;
    },
    isRetailerApproved() {
      return this.$store.getters.isRetailerApproved;
    },
    hideMessages() {
      const isSuspended = this.$store.getters.getUserStatus && this.$store.getters.getUserStatus === "SUSPENDED";
      const isRetailer = this.user.role === "RETAILER";
      return isSuspended && isRetailer;
    },
    ...mapGetters({
      user: "userState",
    }),
  },
  watch: {
    talkSessionLoaded: function () {
      this.mountInbox();
    },
    isRetailerApproved: function (value) {
      if (value === false) {
        this.$router.push("/dashboard/profile");
      }
    },
    hideMessages: async function (value) {
      if (value) {
        await this.showMessageWarningToSuspendedOrDeclinedRetailers();
        this.$router.push("/dashboard/profile");
      }
    },
  },
  methods: {
    mountInbox,
  },
};

async function mountInbox() {
  const userInfo = this.$session.getUserInfo();
  const { data } = userInfo.brand_id ? await BrandService.getBrandMe() : await RetailerService.getMeRetailer();
  await Talk.ready;
  const me = new Talk.User({
    id: userInfo.brand_id ? userInfo.brand_id : userInfo.retailer_id,
    name: `${data.first_name} from ${userInfo.brand_id ? data.brand_name : data.store_name}`,
    email: data.email,
    role: userInfo.role,
  });
  window.messagePageSession = new Talk.Session({
    appId: this.$utils.constants.TALKJS_APP_ID,
    me: me,
  });
  const inbox = messagePageSession.createInbox();
  const talkjsContainer = document.getElementById("talkjs-container");
  if (talkjsContainer) {
    inbox.mount(document.getElementById("talkjs-container"));
  }
}
